// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1JprN","toggleWrap":"styles_toggleWrap__loUSP","content":"styles_content__4Vbxb","selectAreaCode":"styles_selectAreaCode__2KP_h"};